import { useLocation } from 'react-router-dom'
import { SidebarMenuItem } from '@/resources/types'
import * as S from './styles'

interface Props {
  link: SidebarMenuItem
  customCss?: string
  isSubmenuLink?: boolean
  onClick?: () => void
}

const Link = ({ link, customCss, onClick, isSubmenuLink = false }: Props) => {
  const { pathname: currentUrl } = useLocation()

  const destinationLink = link.to ?? ''

  const isSubpage =
    currentUrl.includes(destinationLink) && currentUrl.split('/').length > 2

  const isActive = (menuPath?: string) => currentUrl === menuPath || isSubpage

  const handleClick = () => {
    link.onClick?.()
    onClick?.()
  }

  return (
    <S.Link
      to={destinationLink}
      onClick={handleClick}
      id={link.id}
      customCss={customCss}
      isSubmenu={isSubmenuLink}
      data-active={isActive(link.to)}
    >
      <span>{link.text}</span>
      {link.tag && <S.Tag>{link.tag.text}</S.Tag>}
    </S.Link>
  )
}

export default Link
